import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type ArrowRightIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const ArrowRightIcon: React.FC<ArrowRightIconProps> = ({ width = 12, height = 12, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.79289 5.50004L0 5.50004V6.50004L9.79289 6.50004L6.64645 9.64649L7.35355 10.3536L11.3536 6.35359L11.7071 6.00004L11.3536 5.64648L7.35355 1.64648L6.64645 2.35359L9.79289 5.50004Z" fill={color} />
    </svg>
  </IconSpan>
);
